import React from 'react'
import styled from 'styled-components'
import breakpoints from 'theme/breakpoints'

export default function CarouselSkeleton() {
    return <SlideRect />
}

const SlideRect = styled.div`
    width: 100%;
    aspect-ratio: 16 / 9;
    border-radius: 12px;
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: wave 2.5s infinite linear;

    @keyframes wave {
        0% { background-position: -200px 0; }
        100% { background-position: calc(200px + 100%) 0; }
    }

    @media screen and (min-width: ${breakpoints.lg}) {
        aspect-ratio: 21 / 9;
    }
`;
